import { useState } from "react";
import type { Source } from "@/types/api";

interface SourceListProps {
  sources: Source[];
  idPrefix: string;
}

export function SourceList({ sources, idPrefix }: SourceListProps) {
  const [open, setOpen] = useState(false);
  if (!sources || sources.length === 0) return null;

  return (
    <div className="mt-3 border-t border-border pt-[10px]">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="border-0 bg-transparent p-0 text-[12px] font-semibold text-text-muted hover:text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      >
        Sources checked ({sources.length})
      </button>
      {open && (
        <ol className="mt-[10px] grid list-none gap-[6px] p-0">
          {sources.map((source, index) => {
            const oneBased = index + 1;
            return (
              <li
                key={`${source.kind}:${source.ref ?? source.label}:${index}`}
                id={`${idPrefix}-${oneBased}`}
                className="ndc-source-item rounded-[10px] border border-border bg-surface px-[10px] py-2 text-[12px] text-text-muted transition-colors"
              >
                <span className="mr-1 font-mono text-[11px] text-accent">[{oneBased}]</span>
                {source.ref && source.ref.startsWith("http") ? (
                  <a
                    href={source.ref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-accent no-underline hover:underline"
                  >
                    {source.label || "Source"}
                  </a>
                ) : (
                  <span>{source.label || "Source"}</span>
                )}
                {source.detail ? <span> - {source.detail}</span> : null}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
